// Score and Summary section questionnaire constants
export enum ScoreAndSummaryQuestionnaireItem {
  SCORE_AND_SUMMARY_MODIFIER_A = 'score-and-summary/modifier-a',
  SCORE_AND_SUMMARY_MODIFIER_B = 'score-and-summary/modifier-b',
  SCORE_AND_SUMMARY_CNA_SKILLED_TASKS = 'score-and-summary/cna-skilled-tasks',
  SCORE_AND_SUMMARY_TOTAL = 'score-and-summary/total'
}
